import styled from "styled-components";

const InfoText = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  text-align: center;
  margin-top: 10px;
`

export default InfoText
